export default __webpack_public_path__ + "static/media/brand-hero.b82dca15.webp";